import { render, staticRenderFns } from "./AperturasUnicas.vue?vue&type=template&id=6569ed93"
import script from "./AperturasUnicas.vue?vue&type=script&lang=js"
export * from "./AperturasUnicas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports